function HelpDeskDocumentation() {
  return <>Help Desk Documentation</>;
}

export default HelpDeskDocumentation;
